// frontend/src/App.js
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import Landing from "./page/landing";
import About from "./page/about";
import Signup from "./page/signup";
import Login from "./page/login";
import Dashboard from "./page/dashboard.jsx";
import OtpVerify from "./page/otpverify";
import RegistrationSuccess from "./page/login-success.jsx";
import Lsuccess from "./page/reg-success.jsx";
import Leaderboard from "./page/leaderboard.jsx";
import Rule from "./page/rules.jsx";
import RulebookPage from "./components/rulebook/rulebookpage.jsx";
import Task from "./page/task.jsx";
import Contact from "./page/contact.jsx";
import Faq from "./page/faq.jsx";
import AdminLogin from "./components/admin/AdminLogin";
import AdminDashboard from "./components/admin/AdminDashboard.jsx";
import ManageCAs from "./components/admin/ManageCAs";
import ManageTasks from "./components/admin/ManageTasks";
import ManageSubmissions from "./components/admin/ManageSubmissions";
import ManageLeaderboard from "./components/admin/ManageLeaderboard";
import ManageAnnouncements from "./components/admin/ManageAnnouncements";
import { APP_BASENAME, paths } from "./paths";
import { ProfileProvider } from "./components/context/ProfileContext";

const PrivateRoute = ({ element: Element }) => {
  const isAuthenticated = !!localStorage.getItem("token");
  return isAuthenticated ? <Element /> : <Navigate to={paths.login} />;
};

const AdminPrivateRoute = ({ element: Element }) => {
  const isAdmin = !!localStorage.getItem("adminToken");
  return isAdmin ? <Element /> : <Navigate to={paths.adminLogin} />;
};

function App() {
  return (
    <Router basename={APP_BASENAME}>
      <ProfileProvider>
      <Routes>
        <Route path={paths.home} element={<Landing />} />
        <Route path={paths.about} element={<About />} />
        <Route path={paths.signup} element={<Signup />} />
        <Route path={paths.login} element={<Login />} />
        <Route path={paths.otpVerify} element={<OtpVerify />} />
        <Route path={paths.registrationSuccessSignup} element={<Lsuccess />} />
        <Route
          path={paths.registrationSuccess}
          element={<PrivateRoute element={RegistrationSuccess} />}
        />
        <Route path={paths.dashboard} element={<PrivateRoute element={Dashboard} />} />
        <Route path={paths.leaderboard} element={<PrivateRoute element={Leaderboard} />} />
        <Route path={paths.rule} element={<PrivateRoute element={Rule} />} />
        <Route path={paths.rulebook} element={<RulebookPage />} />
        <Route path={paths.task} element={<PrivateRoute element={Task} />} />
        <Route path={paths.contact} element={<PrivateRoute element={Contact} />} />
        <Route path={paths.faq} element={<PrivateRoute element={Faq} />} />

        <Route path={paths.adminLogin} element={<AdminLogin />} />
        <Route path="/admin" element={<Navigate to={paths.adminDashboard} replace />} />
        <Route path={paths.adminDashboard} element={<AdminPrivateRoute element={AdminDashboard} />} />
        <Route path={paths.adminCas} element={<AdminPrivateRoute element={ManageCAs} />} />
        <Route path={paths.adminTasks} element={<AdminPrivateRoute element={ManageTasks} />} />
        <Route path={paths.adminSubmissions} element={<AdminPrivateRoute element={ManageSubmissions} />} />
        <Route path={paths.adminLeaderboard} element={<AdminPrivateRoute element={ManageLeaderboard} />} />
        <Route path={paths.adminAnnouncements} element={<AdminPrivateRoute element={ManageAnnouncements} />} />

        <Route path="*" element={<Navigate to={paths.home} replace />} />
      </Routes>
      </ProfileProvider>
    </Router>
  );
}

export default App;
